module.exports = __webpack_public_path__ + "img/card-image.0498df41.svg";